import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logoLight from "../../../assets/image/grap04.png";
import logoDark from "../../../assets/image/grap05.png";
import ThemeToggle from "../../../component/theme/ThemeToggle";
import { useTheme } from "../../../component/theme/ThemeContext";
import { HELPDESK_URL, openExternal } from "../../../utils/externalLinks";
import { useTranslation } from "react-i18next";
import styles from "./GuestNaviBar.module.scss";

const GuestNaviBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const themeCtx = useTheme();
  const logo = themeCtx?.theme === 'dark' ? logoDark : logoLight;

  return (
    <>
      <div className={styles['guest-navbar']}>
        {/* LOGO */}
        <div className={styles.wapper}>
          <img
            src={logo}
            alt="logo"
            className={styles.wapper__img}
            onClick={() => navigate('/introduce')}
            style={{ cursor: 'pointer' }}
          />
        </div>

        <div className={styles['guest-navbar__menu']}>
          <div
            className={`${styles['guest-navbar__item']} ${location.pathname === '/introduce' ? styles.active : ''}`}
            onClick={() => navigate('/introduce')}
          >
            {t('nav.overview')}
          </div>
          {/*
            로그인 후 사이드바 Help 메뉴와 같은 곳으로 보냅니다. 문의·라이선스·
            견적을 모두 헬프데스크에서 처리하므로 기존 Contact US 페이지는
            제거했습니다. 외부 링크라 현재 경로와 비교할 대상이 없어 active
            표시는 두지 않습니다.
          */}
          <div
            className={styles['guest-navbar__item']}
            onClick={() => openExternal(HELPDESK_URL)}
            title={t('nav.openHelpdesk')}
          >
            {t('nav.helpdesk')}
          </div>
        </div>

        <div className={styles['guest-navbar__login']}>
          <ThemeToggle />
          <div
            className={`${styles['guest-navbar__item']} ${location.pathname === '/login' ? styles.active : ''}`}
            onClick={() => navigate('/login')}
          >
            {t('nav.login')}
          </div>
        </div>
      </div>
    </>
  );
};

export default GuestNaviBar;
